module.exports = __webpack_public_path__ + "static/media/dwt-01.99918324.jpg";